if (
	typeof wp !== 'undefined' &&
	wp.domReady &&
	wp.richText &&
	wp.richText.unregisterFormatType
) {
	wp.domReady(() => {
		wp.richText.unregisterFormatType('core/language');
		wp.richText.unregisterFormatType('core/math');
	});
}
